import { useEffect, useState } from "react"
import { ethers } from "ethers";
import config from '../config.json'
import abi from '../abi.json'

function Supply(){
    const [minted, setMinted] = useState();
    const [flag, setFlag] = useState();

    const reset = (value) => {
        setFlag(value)
    }
    useEffect(() => {
        getMinted()
    },[])

    const getMinted = async() => {
        try{
            const provider = new ethers.providers.InfuraProvider("mainnet","a6184b6be8424815bdc51ea309e58217");
            const contract = new ethers.Contract(config.CONTRACT_ADDRESS, abi, provider )
            const supply = await new contract.totalSupply()
            setMinted(supply)
        }catch(err){
            console.log(err)
            setFlag(true)
        }
    }

    return(
        <div>
            <div className="mt-2 mb-2"> {minted == null ? <h1 className="text-center text-white font-thin">{`?/ ${config.MAX_SUPPLY} Minted`}</h1> : <h1 className="text-center text-white font-thin">{`${minted} / ${config.MAX_SUPPLY} Minted`}</h1>}</div>
        </div>
    )
}

export default Supply;